import { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import characters from './config/characters';
import { useUnityActions } from 'hooks/unityActions';

const CharacterMenu = ({ onCharacterConfirm }: { onCharacterConfirm: (characterName: string) => void }) => {
  const [selectedCharacterName, setSelectedCharacterName] = useState(characters[0].name);
  const { selectedCharacter, setSelectedCharacter } = useUnityActions();
  const [currentIndex, setCurrentIndex] = useState<null | number>(null);
  const [showCharacterHasChanged, setShowCharacterHasChanged] = useState(false);

  useEffect(() => {
    setSelectedCharacterName(characters[selectedCharacter].name);
  }, []);

  const handleSlideChange = (swiper: any) => {
    setSelectedCharacterName(characters[swiper.realIndex].name);
    setCurrentIndex(swiper.realIndex);
  };

  const handleConfirm = () => {
    setShowCharacterHasChanged(true);
    onCharacterConfirm(selectedCharacterName);
    if (currentIndex) {
      setSelectedCharacter(currentIndex);
    }
  };

  return (
    <div className="z-50 bg-dark w-max h-max rounded-xl relative">
      <div className="character-carousel max-w-full max-h-full pb-4">
        <Swiper
          modules={[Navigation]}
          spaceBetween={50}
          slidesPerView={1}
          navigation={{
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          }}
          loop={true}
          speed={500}
          className='w-[240px] flex justify-center'
          onSlideChange={handleSlideChange}
        >
          {characters.map((character, index) => (
            <SwiperSlide key={index}>
              <img className='mx-auto h-[250px] 2xl:h-[280px]' src={character.img} alt={`Character ${index}`} />
            </SwiperSlide>
          ))}
        </Swiper>

        <div className="carousel-controls flex flex-wrap justify-between items-center w-44 mx-auto h-6 relative">
          <button className="swiper-button-prev !text-white" />

          <div className="flex-1 flex items-center h-full">
            <button className="confirm-button text-lg mx-auto" type='button' onClick={handleConfirm}>
              Confirm
            </button>
          </div>

          <button className="swiper-button-next !text-white" />
        </div>
      </div>
      {showCharacterHasChanged &&
        <div className="absolute top-2 w-full flex items-center">
          <p className="text-blue mx-auto text-xs">Character has been changed</p>
        </div>
      }
    </div>
  );
};

export default CharacterMenu;